import { useQuery } from "@apollo/client";
import { GET_APP_STAFF_SUMMARY_HELP_ROLES } from "graphql/query/staff-summary-help-gql";

const expectedRoles = [
    ["installer", "monteure"],
    ["teamleader", "sub_teamleader"],
];

const getLabels = (data) => {
    const labels = expectedRoles.map(([alias, slug]) => {
        const role = data?.[alias];
        return role?.slug === slug && typeof role.label === "string" ? role.label.trim() : "";
    });
    return labels.every(Boolean) ? labels : null;
};

const useStaffSummaryHelpRoles = ({ enabled }) => {
    const { data, loading, error } = useQuery(GET_APP_STAFF_SUMMARY_HELP_ROLES, {
        skip: enabled !== true,
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
        errorPolicy: "none",
        context: { queryDeduplication: false },
    });

    if (enabled !== true) return { labels: null, loading: false, error: null, unavailable: false };
    if (loading) return { labels: null, loading: true, error: null, unavailable: false };

    const labels = error ? null : getLabels(data);
    return { labels, loading: false, error: error || null, unavailable: labels === null };
};

export default useStaffSummaryHelpRoles;
